import { PropsWithChildren } from 'react'

import { PagesContextDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { PagesContext } from './PagesContext'

export const PagesContextProvider = ({ children }: PropsWithChildren) => {
  const { data, loading } = useQuery(PagesContextDocument)

  const value = {
    canSeePages: data?.handbookPages._policies.seeHandbookPages.can ?? false,
    canEditPages: data?.handbookPages._policies.editHandbookPages.can ?? false,
    loading,
  }

  return <PagesContext.Provider value={value}>{children}</PagesContext.Provider>
}
